import type { NextPage } from 'next';
import SignUp from '@/components/User/SignUp';
import Header from '@/components/Header';
import Footer from '@/components/Footer';

const SignUpPage: NextPage = () => {
  return (
    <>
      <Header />
      <SignUp />
      <Footer />
    </>
  )
}

export default SignUpPage
